import { BookOpen } from "lucide-react";


export const ModuleThumbnail = ({ module, testIdPrefix }) => {
  if (module.image) {
    return (
      <div className="overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white shadow-sm" data-testid={`${testIdPrefix}-thumbnail`}>
        <img src={module.image} alt={module.imageAlt} className="aspect-[5/7] h-full w-full object-cover object-top" />
      </div>
    );
  }

  return (
    <div
      className="flex aspect-[5/7] flex-col justify-between rounded-[1.5rem] border border-stone-200 p-5 text-white shadow-sm"
      style={{ background: "linear-gradient(160deg, rgba(43,43,43,0.96) 0%, rgba(72,72,72,0.94) 55%, rgba(245,166,35,0.88) 100%)" }}
      data-testid={`${testIdPrefix}-thumbnail`}
    >
      <div className="inline-flex w-fit rounded-full border border-white/20 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-white/80">
        {module.code}
      </div>
      <div className="space-y-3">
        <BookOpen className="h-8 w-8 text-white/90" />
        <p className="text-lg font-semibold leading-snug tracking-[-0.02em]">{module.title}</p>
        <p className="text-sm leading-6 text-white/80">Module cover</p>
      </div>
    </div>
  );
};